<div *ngIf="!!errorMessage" class="vzc-warning-banner">
  <mat-icon
    svgIcon="ds-error"
    aria-hidden="false"
    i18n-aria-label="@@S_ACCOUNT_ACTIVATION_WARNING_ICON"
    aria-label="Warning icon"
  ></mat-icon>
  {{ errorMessage }}
</div>
